"use strict";
exports.__esModule = true;
var Row_1 = require("./Row");
var Dataset = /** @class */ (function () {
    function Dataset(_a) {
        var id = _a.id, type = _a.type, label = _a.label, rows = _a.rows, color = _a.color, position = _a.position, percentage = _a.percentage;
        var _this = this;
        this.toJSON = function () { return ({
            id: _this.id,
            type: _this.type,
            label: _this.label,
            rows: _this.rows,
            color: _this.color,
            position: _this.position,
            percentage: _this.percentage
        }); };
        this.id = id;
        this.type = type;
        this.label = label;
        this.rows = rows;
        this.color = color;
        this.position = position;
        this.percentage = percentage;
    }
    Dataset.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, type = _a.type, label = _a.label, rows = _a.rows, color = _a.color, position = _a.position, percentage = _a.percentage;
        if (typeof id !== 'string')
            throw new Error('.id must be a string');
        if (typeof type !== 'string')
            throw new Error('.type must be a string');
        if (typeof label !== 'string')
            throw new Error('.label must be a string');
        if (typeof position !== 'string' && position !== undefined)
            throw new Error('.position must be a string');
        if (typeof percentage !== 'boolean' && percentage !== undefined)
            throw new Error('.percentage must be a string');
        if (typeof color !== 'string' && color !== undefined)
            throw new Error('.color must be a string or undefined');
        var _rows = rows ? rows.map(function (item) { return Row_1["default"].fromJSON(item); }) : undefined;
        return new Dataset({
            id: id,
            type: type,
            label: label,
            rows: _rows,
            color: color,
            position: position,
            percentage: percentage
        });
    };
    return Dataset;
}());
exports["default"] = Dataset;
